import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ur from './locales/ur.json';
import ar from './locales/ar.json';

const applyDocumentLanguage = (lng) => {
  const code = lng || 'en';
  document.documentElement.lang = code;
  document.documentElement.dir = code === 'ar' || code === 'ur' ? 'rtl' : 'ltr';
};

const initialLng = localStorage.getItem('language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ur: { translation: ur },
      ar: { translation: ar },
    },
    lng: initialLng,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

applyDocumentLanguage(initialLng);

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
  applyDocumentLanguage(lng);
});

export default i18n;

